module.exports = __webpack_public_path__ + "img/avatar4.472da3e5.png";